import { TRUST_ASSURANCE_ITEMS } from '../trustCopy';
import { TrustKeyTerms } from '../trustKeyTerms';

export function TrustAssuranceSection() {
  return (
    <section className="text-center">
      <h2 className="font-display text-2xl font-semibold text-white md:text-3xl">
        What this means for you
      </h2>
      <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-gray-300">
        <TrustKeyTerms>
          Like a security trust center for SOC 2, but for AI. This page shows how many of this
          product&apos;s AI decisions were checked, which laws a rule caught something under and when
          the last one was logged, generated by ComplyEdge from live decisions.
        </TrustKeyTerms>
      </p>
      <ul className="mt-10 grid gap-4 text-left md:grid-cols-3">
        {TRUST_ASSURANCE_ITEMS.map((item) => (
          <li key={item.title} className="trust-panel trust-card rounded-2xl p-6">
            <h3 className="font-display text-base font-semibold text-white">
              <TrustKeyTerms>{item.title}</TrustKeyTerms>
            </h3>
            <p className="mt-2.5 text-sm leading-relaxed text-gray-300">
              <TrustKeyTerms>{item.description}</TrustKeyTerms>
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
